import React from 'react';
import { PendingInstallmentsInfo } from '../../types/loanPayment';
import ActiveInjectionAlert from './ActiveInjectionAlert';
import LoanPayout from './loanPayout';

type MortgagePaymentSectionProps = {
  showActiveInjectionAlert: boolean;
  pendingInstallments: PendingInstallmentsInfo;
  collectionServiceUrl: string | null;
  isByRut: boolean;
  prepayIsMoreExpensive: boolean;
  allowAutoRedirect: boolean;
  isAggregateSubpanel: boolean;
};

export default function MortgagePaymentSection({
  showActiveInjectionAlert,
  pendingInstallments,
  collectionServiceUrl,
  isByRut,
  prepayIsMoreExpensive,
  allowAutoRedirect,
  isAggregateSubpanel,
}: MortgagePaymentSectionProps) {
  return (
    <>
      <ActiveInjectionAlert showAlert={showActiveInjectionAlert} />
      <LoanPayout
        pendingInstallments={pendingInstallments}
        collectionServiceUrl={collectionServiceUrl}
        isByRut={isByRut}
        prepayIsMoreExpensive={prepayIsMoreExpensive}
        showPrepayAdvanceHint={false}
        allowAutoRedirect={allowAutoRedirect}
        isAggregateSubpanel={isAggregateSubpanel}
      />
    </>
  );
}
